import React, { useState, useContext, useEffect } from "react";
import { UserContext } from '../UserContext';
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import "../css/consultationform.css";

const ConsultationForm = ({ onSubmit }) => {
    const [Successmessage, setSuccessMessage] = useState("");
    const [Errormessage, setErrorMessage] = useState("");
    const [nameError, setNameError] = useState('');
    const [mobileError, setMobileError] = useState('');
    const [emailError, setEmailError] = useState('');
    const [dateError, setDateError] = useState('');
    const [timeError, setTimeError] = useState('');
    const [isDisabled, setIsDisabled] = useState(false);
    const [showOtpPopup, setShowOtpPopup] = useState(false);
    const [Message, setMessage] = useState();
    const [OTP, setOtp] = useState("");
    const { UserId, user, UserToken, userRole, UserEmail, UserMobile } = useContext(UserContext);
    const isLoggedIn = !!(user && UserToken && userRole);
    const [formData, setFormData] = useState({
        Id: null || UserId,
        Name: "" || user,
        Email: "" || UserEmail,
        MobileNo: "" || UserMobile,
        Time: "",
        Date: "",
        isLoggedIn: isLoggedIn,
        OTP: OTP
    });

    const [showSweetAlert, setShowSweetAlert] = useState(false);
    useEffect(() => {
        let timer;
        if (showSweetAlert) {
            timer = setTimeout(() => {
                setShowSweetAlert(false);
            }, 5000);
        }
        return () => {
            if (timer) {
                clearTimeout(timer);
            }
        };
    }, [showSweetAlert]);

    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });

        if (name === 'Name') {
            if (value === '') {
                setNameError('Name is required');
            } else if (!/^[a-zA-Z\s]+$/.test(value)) {
                setNameError('Please enter valid full name');
            } else {
                setNameError('');
            }
            return;
        }

        if (name === 'MobileNo') {
            if (value === '') {
                setMobileError('Mobile number is required');
            } else if (!/^[6-9]\d{0,9}$/.test(value)) {
                setMobileError('Please enter valid mobile number');
            } else if (value.length < 10) {
                setMobileError('Mobile number must be 10 digits');
            } else if (value.length > 10) {
                setMobileError('Mobile number cannot exceed 10 digits');
            } else {
                setMobileError('');
            }
            return;
        }

        if (name === 'Email') {
            validateEmail(value);
            return;
        }

        if (name === 'Date') {
            if (!value) setDateError('Date is required');
            else setDateError('');
            return;
        }

        if (name === 'Time') {
            if (!value) setTimeError('Time is required');
            else setTimeError('');
            return;
        }

        setFormData({ ...formData, [name]: newValue });
    };

    const handleSubmit = async (e) => {
        e?.preventDefault();

        const { Name, Email, MobileNo, Date: selectedDate, Time: selectedTime } = formData;
        setNameError('');
        setEmailError('');
        setMobileError('');
        setDateError('');
        setTimeError('');
        setErrorMessage('');

        let hasError = false;

        if (!Name.trim()) {
            setNameError('Name is required');
            hasError = true;
        }

        if (!Email.trim()) {
            setEmailError('Email is required');
            hasError = true;
        } else {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(Email)) {
                setEmailError('Please enter a valid email address');
                hasError = true;
            }
        }

        if (!MobileNo.trim()) {
            setMobileError('Mobile number is required');
            hasError = true;
        } else {
            const mobileRegex = /^[6-9]\d{9}$/;
            if (!mobileRegex.test(MobileNo)) {
                setMobileError(' Please enter valid full name mobile number');
                hasError = true;
            }
        }

        if (!selectedDate) {
            setDateError('Date is required');
            hasError = true;
        }

        if (!selectedTime) {
            setTimeError('Time is required');
            hasError = true;
        }

        if (hasError) return;

        const today = new Date();
        const selectedDateObj = new Date(selectedDate + 'T00:00:00');
        if (selectedDateObj < new Date(today.toDateString())) {
            setDateError('You cannot select a past date.');
            return;
        }

        const [hours, minutes] = selectedTime.split(':').map(Number);
        const meetingDateTime = new Date(
            selectedDateObj.getFullYear(),
            selectedDateObj.getMonth(),
            selectedDateObj.getDate(),
            hours,
            minutes,
            0
        );

        const now = new Date();
        if (selectedDateObj.toDateString() === now.toDateString()) {
            const nowPlus30Min = new Date(now.getTime() + 30 * 60000);
            if (meetingDateTime <= nowPlus30Min) {
                setTimeError('For today\'s date, time must be at least 30 minutes ahead of the current time.');
                return;
            }
        }

        setIsDisabled(true);

        try {
            const response = await onSubmit(formData);
            if (response.status === 200) {
                setShowSweetAlert(true);
                setFormData({
                    Name: "",
                    Email: "",
                    MobileNo: "",
                    Time: "",
                    Date: "",
                    OTP: "",
                    Id: "",
                    isLoggedIn: false
                });
                setShowOtpPopup(false);
                setTimeout(() => setSuccessMessage(""), 5000);
                setErrorMessage("");
            }
            else if (response.status === 202) {
                setShowOtpPopup(true);
                setSuccessMessage(response.data.message);
                setTimeout(() => {
                    setSuccessMessage('');
                }, 2000);
            }
            else {
                setMessage(response.data?.message);
                setFormData((prev) => ({
                    ...prev,
                    OTP: ""
                }));
                setTimeout(() => {
                    setMessage("");
                }, 3000);
            }
        } catch (error) {
            setErrorMessage("Something went wrong. Please try again.");
            setSuccessMessage("");
            setFormData((prev) => ({
                ...prev,
                OTP: ""
            }));
        } finally {
            setIsDisabled(false);
        }
    };
    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            setEmailError('Please enter a valid email address');
        } else {
            setEmailError('');
        }
    };

    const handleResendOtp = async () => {
        handleSubmit();
    };

    return (
        <div className="consultationform-card consultationform-div">
            <div className="consultationform-card-body">
                <form onSubmit={handleSubmit}>
                    <label className="consultationform-input-label">Full Name</label>
                    <input
                        type="text"
                        name="Name"
                        placeholder="Enter your name"
                        value={formData.Name}
                        onChange={handleChange}
                        readOnly={isLoggedIn}
                        className="consultationform-input"
                    />
                    {nameError && (
                        <span className="consultationform-error">{nameError}</span>
                    )}

                    <label className="consultationform-input-label">Email Address</label>
                    <input
                        type="email"
                        name="Email"
                        placeholder="Enter your email"
                        value={formData.Email}
                        onChange={handleChange}
                        readOnly={isLoggedIn}
                        className="consultationform-input"
                    />
                    {emailError && (
                        <span className="consultationform-error">{emailError}</span>
                    )}

                    <label className="consultationform-input-label">Mobile No.</label>
                    <input
                        type="tel"
                        name="MobileNo"
                        placeholder="Enter your mobile number"
                        value={formData.MobileNo}
                        onChange={handleChange}
                        maxLength={10}
                        readOnly={isLoggedIn}
                        className="consultationform-input"
                    />
                    {mobileError && (
                        <span className="consultationform-error">{mobileError}</span>
                    )}

                    <label className="consultationform-input-label">Select Preference Date</label>
                    <input
                        type="date"
                        name="Date"
                        value={formData.Date}
                        onChange={handleChange}
                        aria-required={isLoggedIn ? "true" : "false"}
                        className="consultationform-date-input consultationform-input"
                    />
                    {dateError && (
                        <span className="consultationform-error">{dateError}</span>
                    )}

                    <label className="consultationform-input-label">Select Preference Time</label>
                    <input
                        type="time"
                        name="Time"
                        value={formData.Time}
                        onChange={handleChange}
                        aria-required={isLoggedIn ? "true" : "false"}
                        className="consultationform-time-input consultationform-input"
                    />
                    {timeError && (
                        <span className="consultationform-error">{timeError}</span>
                    )}

                    <button type="submit" disabled={isDisabled} className="consultationform-submit-btn">Submit</button>
                </form>
            </div>
            {Errormessage && (
                <div className="consultationform-error">{Errormessage}</div>
            )}

            {showSweetAlert && (
                <div className="consultationform-sweet-alert-container">
                    <div className="consultationform-sweet-alert-content">
                        <button
                            onClick={() => setShowSweetAlert(false)}
                            className="consultationform-sweet-alert-close-btn"
                        >
                            ×
                        </button>
                        <div className="consultationform-sweet-alert-tick-icon">
                            <i className="fas fa-check"></i>
                        </div>
                        <h2 className="consultationform-sweet-alert-title">Success!</h2>
                        <p className="consultationform-sweet-alert-text">
                            Inquiry added successfully <br />
                            Our expert will call you soon.
                        </p>
                    </div>
                </div>
            )}

            {showOtpPopup && (
                <div className="consultationform-otp-popup">
                    <div className="consultationform-otp-content">
                        <span
                            onClick={() => setShowOtpPopup(false)}
                            className="consultationform-otp-close-btn"
                        >
                            ×
                        </span>
                        <h2 className="consultationform-otp-heading">Enter OTP</h2>

                        <input
                            type="tel"
                            maxLength={6}
                            value={formData.OTP}
                            // onChange={(e) => setOtp(e.target.value)}
                            onChange={(e) => setFormData({ ...formData, OTP: e.target.value })}
                            placeholder="Enter 6-digit OTP"
                            className="consultationform-otp-input-field"
                        />

                        <button
                            onClick={handleSubmit}
                            className="consultationform-otp-verify-btn"
                        >
                            Verify OTP
                        </button>

                        <div className="consultationform-resend-otp-text">
                            <span onClick={handleResendOtp}>Resend OTP</span>
                        </div>

                        {Message && (
                            <p className={Message.includes("OTP Verified Successfully !") ? "consultationform-otp-success-msg" : "consultationform-otp-error-msg"}>
                                {Message}
                            </p>
                        )}
                        {Successmessage && (
                            <div className="consultationform-success">{Successmessage}</div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default ConsultationForm;


